var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { tns } from 'tiny-slider/src/tiny-slider';
import { EMAIL_RE } from '../common/utils';
export function initProducts() {
    var single = document.getElementById('singleProduct');
    single && initSingleProduct(single);
}
export function initSingleProduct(root) {
    var galleryEl = root.querySelector('.-gallery');
    var mainImg = [].slice.apply(root.querySelectorAll('.-mainImage'));
    var sharing = root.querySelector('.-sharing');
    var relation = [].slice.apply(root.querySelectorAll('.sproduct-related'));
    galleryEl && initGallery();
    sharing && initSharing();
    relation && relation.forEach(initRelation);
    function initGallery() {
        window.lightGallery(galleryEl, {
            selector: '.-gallery-entry',
            youtubePlayerParams: {
                autoplay: false,
            },
            vimeoPlayerParams: {
                autoplay: false,
            },
        });
        var lg = window.lgData[galleryEl.getAttribute('lg-uid')], firstItem = [].slice.apply(galleryEl.querySelectorAll('.-gallery-entry'))[0];
        if (lg) {
            mainImg.forEach(function (img) {
                img.addEventListener('click', function (event) {
                    event.preventDefault();
                    firstItem && firstItem.dispatchEvent(new Event('click', { cancelable: true, bubbles: true }));
                });
            });
        }
    }
    function initSharing() {
        var button = sharing.querySelector('.-sharing-btn');
        var buttonIcon = button.querySelector('.icon');
        var buttonLabel = button.querySelector('label');
        var form = sharing.querySelector('.-sharing-form');
        var error = form.querySelector('.-error');
        var success = form.querySelector('.-success');
        var input = form.querySelector('.-input');
        var send = form.querySelector('.-send');
        error.addEventListener('click', function () { return hideError(); });
        success.addEventListener('click', function () { return hideSuccess(); });
        error.addEventListener('keydown', function (event) { return (event.key === 'Enter' || event.key === 'Escape') && hideError(); });
        success.addEventListener('keydown', function (event) { return (event.key === 'Enter' || event.key === 'Escape') && hideSuccess(false); });
        button.addEventListener('click', toggle);
        input.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                isEmailValid() && sendEmail();
            }
            else if (event.key === 'Escape') {
                close();
            }
        });
        input.addEventListener('keyup', function (event) {
            send.disabled = !isEmailValid();
        });
        send.addEventListener('click', sendEmail);
        var inputOpen = false;
        var buttonIconClassName = '';
        var buttonLabelText = '';
        function open() {
            setTimeout(function () { return input.focus(); }, 150);
            button.style.width = "".concat(button.offsetWidth, "px");
            buttonIconClassName = buttonIcon.className;
            buttonIcon.className = buttonIcon.className.replace(/icon-\w+/, buttonIcon.dataset.alt);
            buttonLabelText = buttonLabel.innerText;
            buttonLabel.innerText = buttonLabel.dataset.alt;
            button.classList.add('is--active');
            form.classList.add('is--open');
            inputOpen = true;
        }
        function close() {
            input.value = '';
            button.style.width = '';
            buttonIcon.className = buttonIconClassName;
            buttonLabel.innerText = buttonLabelText;
            button.classList.remove('is--active');
            form.classList.remove('is--open');
            hideError(false);
            hideSuccess(false);
            inputOpen = false;
        }
        function toggle() {
            inputOpen ? close() : open();
        }
        function isEmailValid() {
            var val = input.value ? input.value.trim() : '';
            return val && EMAIL_RE.test(val);
        }
        function sendEmail() {
            return __awaiter(this, void 0, void 0, function () {
                var iframe_1;
                return __generator(this, function (_a) {
                    if (isEmailValid()) {
                        iframe_1 = Object.assign(document.createElement('iframe'), {
                            name: 'mailto-iframe',
                        });
                        iframe_1.style.visibility = 'hidden';
                        iframe_1.style.position = 'absolute';
                        iframe_1.style.top = '0';
                        iframe_1.style.pointerEvents = 'none';
                        document.body.appendChild(iframe_1);
                        Object.assign(document.createElement('a'), {
                            href: "mailto:".concat(input.value.trim(), "?subject=").concat(encodeURIComponent(sharing.dataset.emailSubject), "&body=").concat(encodeURIComponent(sharing.dataset.emailBody)),
                            target: 'mailto-iframe',
                        }).click();
                        setTimeout(function () { return document.body.removeChild(iframe_1); }, 2000);
                        //document.body.removeChild(iframe)
                        //sharing.classList.add('is--sending')
                        //sharing.style.pointerEvents = 'none'
                        //try {
                        //  await frontEndApi.post('SingleProduct@shareByEmail', {
                        //    email: input.value.trim(),
                        //    post_id: root.dataset.postId,
                        //  })
                        //  showSuccess()
                        //} catch (err) {
                        //  showError()
                        //}
                        //sharing.classList.remove('is--sending')
                        //sharing.style.pointerEvents = ''
                    }
                    else {
                        console.warn('Email is no-no, que?');
                    }
                    return [2 /*return*/];
                });
            });
        }
        function hideError(focus) {
            if (focus === void 0) { focus = true; }
            error.classList.remove('is--visible');
            focus && setTimeout(function () { return input.focus(); }, 150);
        }
        function showError() {
            error.classList.add('is--visible');
            error.focus();
        }
        function hideSuccess(focus) {
            if (focus === void 0) { focus = true; }
            success.classList.remove('is--visible');
            focus && setTimeout(function () { return input.focus(); }, 150);
        }
        function showSuccess() {
            success.classList.add('is--visible');
            success.focus();
            input.value = '';
        }
    }
    function initRelation(root) {
        var listRoot = root.querySelector('.sproduct-related-list');
        var slider = tns({
            container: listRoot,
            items: 1,
            autoplay: false,
            touch: true,
            mouseDrag: true,
            gutter: 24,
            edgePadding: 48,
            controlsText: ["<span class=\"-turn\"></span>", "<span class=\"-turn\"></span>"],
            nav: false,
            responsive: {
                '1366': {
                    items: 5,
                },
                '1100': {
                    items: 4,
                },
                '800': {
                    items: 3,
                    edgePadding: 0,
                },
                '480': {
                    items: 2,
                },
            },
        });
    }
}
